var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#FFE9D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41667 12.3008C7.16667 12.3008 7 12.4766 7 12.6914V13.6094C7 13.8438 7.16667 14 7.41667 14H10.5833C10.8125 14 11 13.8438 11 13.6094V12.6914C11 12.4766 10.8125 12.3008 10.5833 12.3008H10.1667V8.14062C10.1667 7.92578 9.97917 7.75 9.75 7.75H7.41667C7.16667 7.75 7 7.92578 7 8.14062V9.07812C7 9.29297 7.16667 9.46875 7.41667 9.46875H7.83333V12.3008H7.41667ZM9 4C8.16667 4 7.5 4.64453 7.5 5.40625C7.5 6.1875 8.16667 6.8125 9 6.8125C9.8125 6.8125 10.5 6.1875 10.5 5.40625C10.5 4.64453 9.8125 4 9 4Z",
    fill: "#EB731A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.5a06fbc478ab1b8e11e5ff6fb3f2496e.svg";
export { ForwardRef as ReactComponent };